import Dashboard from "views/Dashboard.js";
import JobSearchWrapper from "views/JobSearch/JobSearchWrapper.js"; // Adjust the path as necessary
import LoginPage from "views/Pages/LoginPage_new.js";
import ChangePassword from "views/Pages/ChangePassword.js";
import EngineerDiary from "views/EngineerDiary.js";

var dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "business_chart-pie-36",
    component: <Dashboard />,
    layout: "/admin",
  },
  {
    path: "/engineerdiary",
    name: "Engineer Diary",
    icon: "ui-1_calendar-60",
    component: <EngineerDiary />, 
    layout: "/admin",
  },
  {
    path: "/jobsearch/:filter/:job", // The :filter indicates a URL parameter named 'filter'
    name: "Job Search",
    icon: "ui-1_zoom-bold",
    component: <JobSearchWrapper />, // Use the wrapper component
    layout: "/admin",
  },
  {
    path: "/login-page",
    name: "Login Page",
    short: "Login",
    mini: "LP",
    component: <LoginPage />,
    layout: "/auth",
    hidden: true
  },
  {
    path: "/change-password",
    name: "Change Password",
    short: "changeP",
    mini: "CP",
    component: <ChangePassword />,
    layout: "/admin",
    hidden: true
  },
];

export default dashRoutes;
